import Container from "@mui/material/Container";
import { reactRouterNestedAncestors, reactRouterParameters } from 'storybook-addon-remix-react-router'
import SendIOPreviewContainer from "./SendIOPreview";
import moment from 'moment-timezone'
import { useOrbit } from "providers/OrbitProvider";


export default {
  title: "Pages/Allocations/SendIOPreview",
  component: SendIOPreviewContainer,
};

const Template = (args) => {
  const { store } = useOrbit()
  const contract = store.cache.query(q => q.findRecords('contract'))?.[0]

  return (
    <Container maxWidth="lg">
      <SendIOPreviewContainer contract={contract} {...args} />
    </Container>
  )
};


const cost_per_enroll_data =  {
  "id": "1109",
  "clientCampaign": {
      "type": "clientCampaign",
      "id": "df459c6d-3ef2-4328-9a32-14001dad6df0",
      "keys": {
          "remoteId": "1109"
      },
      "attributes": {
          "publicId": "ce289134",
          "name": "A CPE Campaign",
          "campaignType": "exclusive",
          "status": "active",
          "createdAt": "2025-05-14T19:01:39.069Z",
          "payout": "cost_per_enroll",
          "customAttributes": {},
          "smartScore": null,
          "smartScoreExplanation": null,
          "billableLeadCount": 0,
          "goodLeadCount": 0,
          "totalCostInCents": 0
      },
      "relationships": {
          "contract": {
              "data": {
                  "type": "contract",
                  "id": "4970fabe-93c1-4c50-9c9f-c449d2b3a106"
              }
          },
          "programGroup": {
              "data": {
                  "type": "programGroup",
                  "id": "348"
              }
          }
      }
  },
  "clientCampaignName": "A CPE Campaign",
  "clientCampaignId": "1109",
  "clientCampaignPublicId": "ce289111",
  "clientCampaignType": "Exclusive",
  "clientCampaignProgramGroup": "All",
  "payout": "cost_per_enroll",
  "smartScore": null,
  "smartScoreExplanation": null,
  "acceptedLeadCount": 0,
  "totalCostInCents": 0,
  "cplInCents": 2500,
  "vendorProjection": null,
  "originalCap": 10,
  "adjustedCap": 15,
  "allocationId": "7856",
  "allocation": {
      "type": "allocation",
      "id": "d97d35ef-fe36-43b0-b20d-3770b3778308",
      "keys": {
          "remoteId": "7856"
      },
      "attributes": {
          "year": 2025,
          "month": 5,
          "cap": 0,
          "cplInCents": 2500,
          "vendorProjection": null,
          "adjustedCap": 15,
          "originalCap": 10,
          "budgetInCents": null
      },
      "relationships": {
          "clientCampaign": {
              "data": {
                  "type": "clientCampaign",
                  "id": "df459c6d-3ef2-4328-9a32-14001dad6df0"
              }
          }
      }
  },
  "vendorName": "Archer Education",
  "budgetInCents": null
}

const variable_cost_per_lead_data = {
  "id": "1108",
  "clientCampaign": {
      "type": "clientCampaign",
      "id": "5cac3991-7bb8-4575-a49a-6dd28d8c8dc9",
      "keys": {
          "remoteId": "1108"
      },
      "attributes": {
          "publicId": "25ac8830",
          "name": "Variable CPL Camp",
          "campaignType": "exclusive",
          "status": "active",
          "createdAt": "2025-05-13T20:55:00.933Z",
          "payout": "variable_cost_per_lead",
          "customAttributes": {},
          "smartScore": null,
          "smartScoreExplanation": null,
          "billableLeadCount": 0,
          "goodLeadCount": 0,
          "totalCostInCents": 0
      },
      "relationships": {
          "contract": {
              "data": {
                  "type": "contract",
                  "id": "4970fabe-93c1-4c50-9c9f-c449d2b3a106"
              }
          },
          "programGroup": {
              "data": {
                  "type": "programGroup",
                  "id": "348"
              }
          }
      }
  },
  "clientCampaignName": "Variable CPL Camp",
  "clientCampaignId": "1108",
  "clientCampaignPublicId": "25ac8822",
  "clientCampaignType": "Exclusive",
  "clientCampaignProgramGroup": "All",
  "payout": "variable_cost_per_lead",
  "smartScore": null,
  "smartScoreExplanation": null,
  "acceptedLeadCount": 0,
  "totalCostInCents": 0,
  "cplInCents": 720,
  "vendorProjection": null,
  "originalCap": 0,
  "adjustedCap": null,
  "allocationId": "7854",
  "allocation": {
      "type": "allocation",
      "id": "6e1d595c-ce41-436e-a02b-a317886bbf05",
      "keys": {
          "remoteId": "7854"
      },
      "attributes": {
          "year": 2025,
          "month": 5,
          "cap": 0,
          "cplInCents": 720,
          "vendorProjection": null,
          "adjustedCap": null,
          "originalCap": 0,
          "budgetInCents": 10000
      },
      "relationships": {
          "clientCampaign": {
              "data": {
                  "type": "clientCampaign",
                  "id": "5cac3991-7bb8-4575-a49a-6dd28d8c8dc9"
              }
          }
      }
  },
  "vendorName": "Archer Education",
  "budgetInCents": 10000
}

const Default = {
  render: Template,
  parameters: {
    reactRouter: reactRouterParameters({
      location: {
        pathParams: { clientId: '123' },
      },
      routing: reactRouterNestedAncestors([
        {
          path: 'clients',
        },
        {
          path: ':clientId',
        },
        {
          path: 'allocations',
        }
      ]),
    }),
    orbit: {
      user: {
        permitSystemAdmin: true,
        email: 'bob@cygnus.com',
      },
      records: [
        {
          type: "clients",
          id: "123",
          attributes: {
            id: 134,
            name: "American InterContinental University",
            "created-at": "2020-11-05T16:35:35.962Z",
            "updated-at": "2021-10-05T13:29:17.510Z",
            "secondary-color": "#0065A4",
            "primary-color": "#474A59",
            "tcpa-disclosure":
            "By checking this box and providing my contact information, I am giving American InterContinental University, a member of the AIU system, consent to contact me by email or telephone, including by text message regarding educational services. I acknowledge these calls may be pre-recorded messages and/or generated using an automated dialing system. I understand that I am under no obligation to provide consent to purchase any goods or services. Msg and data rates may apply",
            "internal-name": "American InterContinental University",
            "lp-email-sender": null,
            "lp-area-codes": null,
            "lp-continue-url": null,
            "response-time": "five_minutes",
            "implicit-tcpa": false,
            "google-conversion-id": null,
            "complyed-client-id": "102",
            "campus-explorer-college-id": null,
            "num-programs": 3,
            aor: false,
            "contact-name": null,
            "contact-email": null,
            "contact-address": null,
            "contact-city": null,
            "contact-state": null,
            "contact-zip": null,
            "contact-phone": null,
            "time-zone": "America/New_York",
            notes: "test",
            logo: null,
            "compliance-logo": null,
            "brand-guidelines-document": null,
            "brand-guidelines-document-filename": null,
          },
        },
        {
          type: "vendors",
          id: "1",
          attributes: {
            id: 1,
            name: "Cygnus Education",
            "created-at": "2021-01-25T01:26:50.313Z",
            "updated-at": "2021-01-25T01:26:50.313Z",
            "contact-name": null,
            "contact-email": "default-contact@vendor.com",
            "street-address": null,
            city: null,
            state: null,
            "zip-code": null,
            phone: null,
            "external-config": {},
          },
          relationships: { organization: { data: { id: "1", type: "organizations" } } },
        },
        {
          type: "contracts",
          id: "45",
          relationships: {
            client: { data: { id: "123", type: "clients" } },
            vendor: { data: { id: "1", type: "vendors" } },
          },
          attributes: {
            "vendorCode": null,
            "canPostLeads": false,
            "vendorContactName": null,
            "vendorContactEmail": 'sally@vendor.com',
            "vendorNotes": null,
          },
        },
      ],
    },
  },
  args: {
    data: [
      {
          "id": "662",
          "clientCampaign": {
              "type": "clientCampaign",
              "id": "654ce10f-7ff7-496a-8ae4-7090fc049ded",
              "keys": {
                  "remoteId": "662"
              },
              "attributes": {
                  "publicId": "8b198833",
                  "name": "ARCHER EDUCATION ",
                  "campaignType": "exclusive",
                  "status": "active",
                  "createdAt": "2023-07-14T15:46:28.551Z",
                  "payout": "cost_per_lead",
                  "customAttributes": {},
                  "smartScore": null,
                  "smartScoreExplanation": null,
                  "billableLeadCount": 0,
                  "goodLeadCount": 0,
                  "totalCostInCents": 0
              },
              "relationships": {
                  "contract": {
                      "data": {
                          "type": "contract",
                          "id": "4970fabe-93c1-4c50-9c9f-c449d2b3a106"
                      }
                  },
                  "programGroup": {
                      "data": {
                          "type": "programGroup",
                          "id": "348"
                      }
                  }
              }
          },
          "clientCampaignName": "ARCHER EDUCATION ",
          "clientCampaignId": "662",
          "clientCampaignPublicId": "8b198833",
          "clientCampaignType": "Exclusive",
          "clientCampaignProgramGroup": "All",
          "payout": "cost_per_lead",
          "smartScore": null,
          "smartScoreExplanation": null,
          "acceptedLeadCount": 0,
          "totalCostInCents": 0,
          "cplInCents": 1000,
          "vendorProjection": null,
          "originalCap": 0,
          "adjustedCap": null,
          "allocationId": "7425",
          "allocation": {
              "type": "allocation",
              "id": "5f07f004-d669-4091-bcc7-04413f5bd28a",
              "keys": {
                  "remoteId": "7425"
              },
              "attributes": {
                  "year": 2025,
                  "month": 5,
                  "cap": 0,
                  "cplInCents": 1000,
                  "vendorProjection": null,
                  "adjustedCap": null,
                  "originalCap": 0,
                  "budgetInCents": null
              },
              "relationships": {
                  "clientCampaign": {
                      "data": {
                          "type": "clientCampaign",
                          "id": "654ce10f-7ff7-496a-8ae4-7090fc049ded"
                      }
                  }
              }
          },
          "vendorName": "Archer Education",
          "budgetInCents": null
      },
      {
          "id": "664",
          "clientCampaign": {
              "type": "clientCampaign",
              "id": "2e00a828-a73c-43a5-ad8f-979706e9079c",
              "keys": {
                  "remoteId": "664"
              },
              "attributes": {
                  "publicId": "b009e644",
                  "name": "ARCHER EDUCATION - ORGANIC",
                  "campaignType": "exclusive",
                  "status": "active",
                  "createdAt": "2023-07-14T15:46:42.662Z",
                  "payout": "cost_per_lead",
                  "customAttributes": {},
                  "smartScore": null,
                  "smartScoreExplanation": null,
                  "billableLeadCount": 0,
                  "goodLeadCount": 0,
                  "totalCostInCents": 0
              },
              "relationships": {
                  "contract": {
                      "data": {
                          "type": "contract",
                          "id": "4970fabe-93c1-4c50-9c9f-c449d2b3a106"
                      }
                  },
                  "programGroup": {
                      "data": {
                          "type": "programGroup",
                          "id": "348"
                      }
                  }
              }
          },
          "clientCampaignName": "ARCHER EDUCATION - ORGANIC",
          "clientCampaignId": "664",
          "clientCampaignPublicId": "b009e644",
          "clientCampaignType": "Exclusive",
          "clientCampaignProgramGroup": "All",
          "payout": "cost_per_lead",
          "smartScore": null,
          "smartScoreExplanation": null,
          "acceptedLeadCount": 0,
          "totalCostInCents": 0,
          "cplInCents": 500,
          "vendorProjection": null,
          "originalCap": 25,
          "adjustedCap": null,
          "allocationId": "7548",
          "allocation": {
              "type": "allocation",
              "id": "b29e4409-2f07-4531-85b3-a40ca6ffa8db",
              "keys": {
                  "remoteId": "7548"
              },
              "attributes": {
                  "year": 2025,
                  "month": 5,
                  "cap": 0,
                  "cplInCents": 500,
                  "vendorProjection": null,
                  "adjustedCap": null,
                  "originalCap": 0,
                  "budgetInCents": null
              },
              "relationships": {
                  "clientCampaign": {
                      "data": {
                          "type": "clientCampaign",
                          "id": "2e00a828-a73c-43a5-ad8f-979706e9079c"
                      }
                  }
              }
          },
          "vendorName": "Archer Education",
          "budgetInCents": null
      }
    ],
    month: moment('2025-05-01T04:00:00.000Z'),
  },
}

export const AllTypes = {
  ...Default,
  args: {
    ...Default.args,
    data: [
      ...Default.args.data,
      cost_per_enroll_data,
      variable_cost_per_lead_data
    ]
  }
}

export const CPL_And_VCPL = {
  ...Default,
  args: {
    ...Default.args,
    data: [
      ...Default.args.data,
      variable_cost_per_lead_data
    ]
  }
}

export const CPE_Only = {
  ...Default,
  args: {
    ...Default.args,
    data: [
      cost_per_enroll_data
    ]
  }
}

export const VCPL_Only = {
  ...Default,
  args: {
    ...Default.args,
    data: [
      variable_cost_per_lead_data
    ]
  }
}
